import App from 'src/App.jsx';
import Root from 'src/Root';

// Single Vike page covering every URL (see ./+route.ts). All in-app
// routing happens inside <App /> via react-router, so adding new routes
// requires no changes here.
//
// Wrapping with <Root /> at the page level (instead of vike-react's
// +Wrapper) keeps the provider stack out of the server entry: with
// ssr: false this whole module is client-only, while +Wrapper would
// load on the server too and pull in CJS deps like lodash via
// SiteGuardContext -> baseApi -> lodash.
export default function Page() {
   return (
      <Root>
         <App />
      </Root>
   );
}
